import { authContext } from 'contexts/'
import { LocationDescriptor } from 'history'
import { useContext, useEffect, useState } from 'react'
import { Redirect, useLocation } from 'react-router'
import { IPrivateGuardProps } from './private-guard-props.interface'

const PrivateGuard: React.FC<IPrivateGuardProps> = ({ children }) => {
  const auth = useContext(authContext)
  const { pathname, search } = useLocation()
  const [redirectToLogin, setRedirectToLogin] = useState<boolean>(!(!!auth?.user || !!auth?.changeToken))
  const [redirectTo] = useState<LocationDescriptor>({
    pathname: '/login',
    search: `?redirectTo=${encodeURIComponent(pathname + search)}`,
    state: { from: pathname },
  })

  useEffect(() => {
    if (!!auth?.user || !!auth?.changeToken) {
      setRedirectToLogin(false)
    }
  }, [auth?.user, auth?.changeToken])

  return redirectToLogin ? <Redirect to={redirectTo ?? '/'} /> : <> {children}</>
}

export default PrivateGuard
